import SteamID from 'steamid'
import {
  USER_INFO, USER_BALANCE,
  USER_BANNED, USER_BALANCE_DIFF, USER_PROP_UPDATE,
  DISCONNECTED, CHAT_MUTED, CHAT_UNMUTED,
  USER_TX_UPDATE, USER_XP_DIFF, USER_NOTIFICATION, CONNECTED,
  USER_INVENTORY_ADD, USER_INVENTORY_REMOVE, USER_INVENTORY_REPLACE, USER_TRADE_UPDATE,
} from '@/utils/constants/socket-events'
import User from '@/store/models/user/User'
import Notification from '@/store/models/user/Notification'
import Item from '@/store/models/user/Item'
import Trade from '@/store/models/user/Trade'
import * as NOTIF from '@/utils/constants/notification-types'
import EventBus from '@/plugins/eventbus'

export default {
  [`SOCKET_${USER_INFO}`]({ commit }, data) {
    if (!data) {
      commit('setSession', null)
      return
    }

    const user = new User({
      ...data,
      shortId: new SteamID(data.steamid).accountid,
    })

    commit('setSession', user)

    // shit we do when we first get user

    if (!user.tradeUrl) {
      Notification.insertOrUpdate({
        data: {
          id: NOTIF.SETTINGS_TRADEURL_MISSING,
          type: NOTIF.SETTINGS_TRADEURL_MISSING,
          action: {
            type: 'modal',
            action: 'open',
            name: 'account',
            settings: { maxWidth: 1000 },
            payload: { tab: 'settings' },
          },
          persistent: true,
        },
      })
    }
  },
  [`SOCKET_${USER_BANNED}`]({ commit }, ban) {
    commit('setBanned', ban)
  },
  [`SOCKET_${USER_BALANCE}`]({ commit }, value) {
    commit('setUserBalance', value)
  },
  [`SOCKET_${USER_BALANCE_DIFF}`]({ commit }, difference) {
    commit('addOrRemoveBalance', difference)
  },
  [`SOCKET_${USER_XP_DIFF}`]({ commit, getters }, difference) {
    if (difference > 0) {
      const oldXp = getters.session?.xp ?? 0
      EventBus.$emit('user.xp', { oldXp, xp: difference })
    }

    const oldLevel = getters.session.level
    commit('incUserProp', ['xp', difference])

    const newLevel = getters.session.level
    if (newLevel > oldLevel) {
      Notification.insertOrUpdate({
        data: {
          id: NOTIF.LEVEL_UP,
          type: NOTIF.LEVEL_UP,
          action: {
            type: 'modal',
            action: 'open',
            name: 'account',
            settings: { maxWidth: 1000 },
            payload: { tab: 'account' },
          },
        },
      })
    }
  },
  [`SOCKET_${USER_PROP_UPDATE}`]({ commit }, [field, val]) {
    commit('setUserProp', [field, val])
  },
  [`SOCKET_${USER_TX_UPDATE}`]({ commit }, {
    id, status, type, method,
  }) {
    Notification.dispatch('create', {
      id,
      type: NOTIF.TX_STATUS,
      action: {
        type: 'modal',
        action: 'open',
        name: 'account',
        settings: { maxWidth: 1000 },
        payload: { tab: 'transactions' },
      },
      data: { status, type, method },
    })
  },
  async [`SOCKET_${USER_TRADE_UPDATE}`]({ commit, getters }, data) {
    const exists = await Notification.exists(data.id)

    const { trades: [trade] } = await Trade.insertOrUpdate({ data })

    // trade modal if new trade
    if (!exists && trade.isActive) {
      const { _vm: vm } = this
      vm.$modal.open('trade-offer-ready', { maxWidth: 350 }, { trade })
    }

    if (getters.pendingTrades.length) {
      Notification.insertOrUpdate({
        data: {
          id: NOTIF.TRADE_ACTIVE,
          type: NOTIF.TRADE_ACTIVE,
          action: {
            type: 'modal',
            action: 'open',
            name: 'account',
            settings: { maxWidth: 1000 },
            payload: { tab: 'trades' },
          },
          persistent: true,
        },
      })
    } else {
      Notification.delete(NOTIF.TRADE_ACTIVE)
    }
  },
  [`SOCKET_${DISCONNECTED}`]({ commit }, { event }) {
    // TODO check if auth invalidated
    // if (event.code === 4001) {
    //   socket.autoReconnect = false
    //   await store.dispatch('user/logout')
    //   return
    // }

    // user was logged out elsewhere
    if (event.code === 4002) {
      commit('setSession', null)
    }
  },
  [`SOCKET_${CONNECTED}`]({ dispatch, getters }) {
    if (getters.session) {
      dispatch('getPendingTrades')
    }
  },
  async [`SOCKET_${CHAT_MUTED}`](_, { reason, duration }) {
    await Notification.dispatch('create', {
      type: NOTIF.USER_MUTED,
      data: { reason, duration },
    })
  },
  async [`SOCKET_${CHAT_UNMUTED}`]() {
    await Notification.dispatch('create', { type: NOTIF.USER_UNMUTED })
  },
  async [`SOCKET_${USER_NOTIFICATION}`]({ rootState }, data) {
    if (!data.type) return

    const { route, windowVisible } = rootState

    // don't show navigation notifications if already on said page
    if (data.action?.type === 'navigation' && windowVisible) {
      if (data.action.name === route.name) return
      if (data.action.path === route.fullPath) return
    }

    await Notification.dispatch('create', data)
  },
  // inventory
  [`SOCKET_${USER_INVENTORY_REPLACE}`]({ commit, rootGetters }, data) {
    const itemdb = rootGetters['items/items']
    const items = data.map(i => new Item({ ...i, ...itemdb[i.name] }))

    commit('setInventory', items)
  },
  [`SOCKET_${USER_INVENTORY_ADD}`]({ commit, rootGetters }, data) {
    const itemdb = rootGetters['items/items']
    const items = data.map(i => new Item({ ...i, ...itemdb[i.name], isNew: true }))

    commit('addItems', items)
  },
  [`SOCKET_${USER_INVENTORY_REMOVE}`]({ commit }, ids) {
    commit('removeItems', ids)
  },
}
